import {useTranslation} from 'react-i18next'
import {SidebarLink} from '@/components/sidebar-link'
import {SidebarSection} from '@/components/sidebar-section'

export function SidebarEmpresa({
  businessId,
  isOwner,
  canLeadArea,
}: {
  businessId: string
  isOwner: boolean
  canLeadArea: boolean
}) {
  const {t} = useTranslation()
  return (
    <SidebarSection id="empresa" context="tenant" label={t('nav.sectionEmpresa')}>
      <SidebarLink to={`/businesses/${businessId}/profile`} testId="nav-profile">
        {t('nav.profile')}
      </SidebarLink>
      {/* Owner-only: a responsable operates the SG-SST, never the commercial relationship with Kairos. */}
      {isOwner && (
        <SidebarLink to={`/businesses/${businessId}/plan`} testId="nav-plan-facturacion">
          {t('nav.planFacturacion')}
        </SidebarLink>
      )}
      {/* En EMPRESA y no en SG-SST: son decisiones de gestión, no artefactos del ciclo PHVA. */}
      <SidebarLink to={`/businesses/${businessId}/cifras`} testId="nav-cifras">
        {t('nav.cifras')}
      </SidebarLink>
      <SidebarLink to={`/businesses/${businessId}/employees`} testId="nav-employees">
        {t('nav.employees')}
      </SidebarLink>
      <SidebarLink to={`/businesses/${businessId}/examenes`} testId="nav-examenes" indented>
        {t('nav.matrizExamenes')}
      </SidebarLink>
      <SidebarLink to={`/businesses/${businessId}/organigrama`} testId="nav-organigrama">
        {t('nav.organigrama')}
      </SidebarLink>
      {/* En EMPRESA y no en SG-SST: es la operación diaria, no un artefacto del ciclo PHVA. */}
      <SidebarLink to={`/businesses/${businessId}/obras`} testId="nav-obras">
        {t('nav.obras')}
      </SidebarLink>
      {/* Directorio de operación continua, no un estándar condicional (constructores-estandar-spec §4). */}
      <SidebarLink to={`/businesses/${businessId}/proveedores`} testId="nav-proveedores">
        {t('nav.proveedores')}
      </SidebarLink>
      {canLeadArea && (
        <SidebarLink to={`/businesses/${businessId}/mi-area`} testId="nav-mi-area">
          {t('nav.miArea')}
        </SidebarLink>
      )}
    </SidebarSection>
  )
}
